export default "__VITE_ASSET__BODx2oV4__"